import Cookies from 'js-cookie'

const initialize = () => {
    //JS based double-submit CSRF protection
    //https://cheatsheetseries.owasp.org/cheatsheets/Cross-Site_Request_Forgery_Prevention_Cheat_Sheet.html#double-submit-cookie
    //random token generation
    let chars = '0123456789abcdefghijklmnopqrstuvwxyz!@#$%^&*()ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    let password = '';
    const array = new Uint32Array(chars.length);
    window.crypto.getRandomValues(array);
    for (let i = 0; i < 28; i++) {
        password += chars[array[i] % chars.length];
    }
    const csrfDoubleSubmitToken = password;

    // const doubleSubmitCookieData = { name: 'csrf_double_submit', value: csrfDoubleSubmitToken };
    // console.log(['generated new token', doubleSubmitCookieData]);
    const domainParts = window.location.hostname.split('.').reverse();
    const domainName =  domainParts[1] + '.' + domainParts[0];
    // biscuit.setIt(doubleSubmitCookieData.name, doubleSubmitCookieData.value, null, '/', domainName, true, 'lax');
    Cookies.set('csrf_double_submit', csrfDoubleSubmitToken, {domain: '.' + domainName, SameSite: 'None', Secure: true});

    const csrfDoubleSumitField = document.querySelector('#impersonate_login input[name=_token]');
    if (csrfDoubleSumitField) {
        csrfDoubleSumitField.value = csrfDoubleSubmitToken;
    }

    window.setTimeout(
        document.impersonate_login.submit.bind(document.impersonate_login),
        5000
    );
};

export default initialize;
